import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProgressBar from '../components/shared/ProgressBar';
import Step1 from '../steps/Step1';
import Step2 from '../steps/Step2';
import Step3 from '../steps/Step3';
import Step4 from '../steps/Step4';
import Step5 from '../steps/Step5';
import { setRegistrationStep } from '../store/userSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import ReusableLayout from '../components/ReusableLayout';

const STEP_TITLES = {
  1: 'Как вас зовут',
  2: 'Добавьте фото',
  3: 'Напишите пару слов о себе',
  4: 'Расскажите, для чего вы здесь',
  5: 'Добавьте ваши интересы',
};

function CalculatePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const registrationStep = useSelector((state) => state.user.registrationStep);

  const locationStateSteps = Array.isArray(location.state?.steps) ? location.state.steps : [];
  const isCustomFlow = locationStateSteps.length > 0;
  const activeSteps = isCustomFlow ? locationStateSteps : [1, 2, 3, 4, 5];

  // Возвращаемся на сохранённый шаг, если пользователь уже начал регистрацию
  const [step, setStep] = useState(() => {
    if (!isCustomFlow && activeSteps.includes(registrationStep)) {
      return registrationStep;
    }
    return activeSteps[0] ?? 1;
  });
  const progressBarRef = useRef(null);
  const stepRegionRef = useRef(null);

  useEffect(() => {
    const progressBarNode = progressBarRef.current;

    if (!progressBarNode) {
      return;
    }

    const frameId = window.requestAnimationFrame(() => {
      progressBarNode.scrollIntoView({
        behavior: step === 1 ? 'auto' : 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [step]);

  // Запоминаем шаг и переносим фокус, чтобы скринридер объявил новый экран
  useEffect(() => {
    if (!isCustomFlow) {
      dispatch(setRegistrationStep(step));
    }

    stepRegionRef.current?.focus({ preventScroll: true });
  }, [step]);

  const handleNextStep = () => {
    const currentIndex = activeSteps.indexOf(step);
    const nextStep = activeSteps[currentIndex + 1];

    if (nextStep !== undefined) {
      setStep(nextStep);
      return;
    }

    dispatch(setRegistrationStep(null));
    navigate('/meet');
  };

  const stepTitle = STEP_TITLES[step] || '';
  const stepNumber = activeSteps.indexOf(step) + 1;

  return (
    <ReusableLayout variant="fullscreen">
      <div ref={progressBarRef} className={`w-full min-h-full flex-1 overflow-auto`}>
        <ProgressBar
          current={step}
          max={6}
          onArrowClick={
            step >= 2
              ? () => setStep((prev) => prev - 1)
              : () => {
                  navigate(-1);
                }
          }
        />

        {/* Шаги */}
        <div
          ref={stepRegionRef}
          tabIndex={-1}
          role="region"
          aria-label={`Шаг ${stepNumber} из ${activeSteps.length}: ${stepTitle}`}
          className="outline-none"
        >
          {step === 1 && <Step1 setStep={handleNextStep} />}
          {step === 2 && <Step2 setStep={handleNextStep} />}
          {step === 3 && <Step3 setStep={handleNextStep} />}
          {step === 4 && <Step4 setStep={handleNextStep} />}
          {step === 5 && <Step5 setStep={handleNextStep} />}
        </div>
      </div>
    </ReusableLayout>
  );
}

export default CalculatePage;
